import Q from 'q';

import type { ActionContext } from 'js/lib/ActionContext';
import user from 'js/lib/user';

import ProgressStoreClass from 'bundles/in-course-stores/stores/ProgressStore';
import { getHomeProgress } from 'bundles/ondemand/utils/homeProgressApi';

const DEFAULT_PROGRESS = {
  modulesCompleted: [],
  modulesPassed: [],
};

export default (actionContext: ActionContext, courseId: string): Q.Promise<any> => {
  if (actionContext.getStore(ProgressStoreClass).hasLoaded()) {
    return Q();
  }

  if (user.isAuthenticatedUser()) {
    // Failures aren't handled properly in SSR: https://coursera.atlassian.net/browse/AUTHORING-7488
    return getHomeProgress(courseId)
      .then((data) => {
        const progress = data.elements && data.elements.length ? data.elements[0] : DEFAULT_PROGRESS;
        actionContext.dispatch('LOAD_HOME_PROGRESS', progress);
      })
      .fail(() => {
        actionContext.dispatch('LOAD_HOME_PROGRESS', DEFAULT_PROGRESS);
      });
  } else {
    actionContext.dispatch('LOAD_HOME_PROGRESS', DEFAULT_PROGRESS);

    return Q();
  }
};
